import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/app.css";
import { App } from "./App";
import { applyTheme, readTheme } from "./theme";

applyTheme(readTheme());

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// 오프라인 셸(PWA) — 배포본에서만. 등록 실패는 조용히 넘긴다(앱은 그대로 동작)
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  // 배포 직후처럼 sw.js 대신 index.html 이 돌아오면 등록하지 않는다(브라우저가 MIME 오류를 콘솔에 찍기 때문)
  window.addEventListener("load", () => {
    fetch("./sw.js", { method: "HEAD", cache: "no-store" })
      .then((r) => { if (r.ok && /javascript/.test(r.headers.get("content-type") || "")) return navigator.serviceWorker.register("./sw.js"); })
      .catch(() => {});
  });
}
